import { Component, OnInit, Optional, Inject, ViewChild, EventEmitter } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MAT_DIALOG_DATA, MatSort } from '@angular/material';
import { PanelAsignService } from 'src/app/shared/panel-assign/panel-assign.service';
import { Candidate } from 'src/app/model/candidate.model';
import { SelectionModel } from '@angular/cdk/collections';
import { PanelService } from 'src/app/shared/panel-service/panel.service';
import { NotificationService } from 'src/app/shared/notification.service';

export interface DialogData {
  processId: number;
  panelId: number;
}

@Component({
  selector: 'app-add-more-candidate-model',
  templateUrl: './add-more-candidate-model.component.html',
  styleUrls: ['./add-more-candidate-model.component.scss']
})
export class AddMoreCandidateModelComponent implements OnInit {

  updatePanelList = new EventEmitter();

  filterName: string;  
  candidateList = [];
  listData: MatTableDataSource<any>;
  private candidates: Candidate[];
  private processId: number;
  private onEditPanelId: number;
  assignedCandidateListData = [];                                                        //, 'contactNo'
  
  displayedColumns: string[] = ['position', 'select', 'candidateName', 'assigned', 'email', 'gender', 'address', 'totalMarks', 'score'];

  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private panelService: PanelService,
    private panelAsignService: PanelAsignService,
    public notificationService: NotificationService,
    public dialogRef: MatDialogRef<AddMoreCandidateModelComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public element: DialogData
  ) {
    this.processId = element.processId;
    this.onEditPanelId = element.panelId;
  }

  //for Check Box Selection in a table
  selection = new SelectionModel<any>(true, []);

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    if (this.listData != null) {
      const numSelected = this.selection.selected.length;
      const numRows = this.listData.data.length;
      return numSelected === numRows;
    }
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.listData.data.forEach(row => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  ngOnInit() {
    this.getAvailableCandidates();
  }
  getAllAssignedPanel() {
    this.panelAsignService.getPanelCandidate(this.onEditPanelId).then(
      panelAssignedDetails => {
        for (let i = 0; i < panelAssignedDetails.length; i++) {
          this.assignedCandidateListData.push(panelAssignedDetails[i].candidateId);
        }
      },
      err => {
        console.log(err);
      }
    );

  }
  getAvailableCandidates() {
    this.panelService.availableCandidate(this.processId).then(
      candidates => {
        this.candidates = candidates;
        if (this.candidates.length != 0) {
          this.listData = new MatTableDataSource(candidates);
          this.listData.sort = this.sort;
          this.getAllAssignedPanel();
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  applyFilter(filterValue: string) {
    this.listData.filter = filterValue.trim().toLowerCase();
  }
  onClear() {
    this.listData.filter = '';
    this.filterName = '';
  }
  onClose() {
    this.dialogRef.close();
  }

  onSubmitApply() {
    console.log(this.selection.selected);
    let candidateIdArray = this.getCandidateList(this.selection.selected);
    let jsonObject = {};
    jsonObject['candidateIds'] = candidateIdArray;
    this.panelService.addMoreCandidates(jsonObject, this.onEditPanelId)
    .then(
      res => {
        try {
          this.updatePanelList.emit(res);
          window.location.reload();
          this.onClose();
        } catch (error) {
          this.updatePanelList.emit(error);
          this.onClose();
        }
      }, err => {
        window.location.reload();
      }
    )
    
  }
  
  getCandidateList(tableRow: any) {
    let candidateList = [];
    for (let i = 0; i < tableRow.length; i++) {
      candidateList.push(tableRow[i].candidateId);
    }
    return candidateList;
  }

  getPanelMemberList(tableRow: any) {
    let panelMemberList = [];
    for (let i = 0; i < tableRow.length; i++) {
      panelMemberList.push(tableRow[i].panelMemberId);
    }
    return panelMemberList;
  }

  getCandidateIdForRow(panelCandidate: any) {
    if (panelCandidate) {
      return panelCandidate.candidateId;
    } else {
      return "";
    }
  }
}
